import i18next from 'i18next';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
  name: Yup.string().required(i18next.t('validation.subjects.nameRequired')),
  shortName: Yup.string().required(i18next.t('validation.subjects.shortNameRequired')),
});
